import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Box, Typography, List, ListItem, ListItemButton, Paper } from "@mui/material";
import ContactInformation from "./ContactInformation";
import "./allpolicies_module.css";

const AllPolicies = () => {
  const navigate = useNavigate();

  const policies = [
    {
      title: "Privacy Policy",
      path: "/privacy-policy",
      description: "Learn how we collect and use your personal information",
    },
    {
      title: "Data Privacy",
      path: "/data-privacy",
      description: "Understand how your data is protected and managed",
    },
    {
      title: "Vendor Policy",
      path: "/vendor-policy",
      description: "Guidelines for vendors and service providers",
    },
    {
      title: "User Policy",
      path: "/user-policy",
      description: "Terms and policies for using our platform",
    },
    {
      title: "Cancellation & Refund Policy",
      path: "/Cancellation-Refund_Policy",
      description: "Learn about our cancellation and refund procedures",
    },
    {
      title: "Shipping & Delivery Policy",
      path: "/Shipping_DeliveryPolicy",
      description: "Information about shipping and delivery of services",
    },
  ];

  return (
    <Container maxWidth="md" sx={{ py: 5 }}>
      <Box sx={{ textAlign: "center", mb: 5 }}>
        <Typography
          variant="h4"
          component="h1"
          sx={{
            fontWeight: "bold",
            color: "#0693e3",
            mb: 2,
          }}
        >
          Our Policies
        </Typography>
        <Typography variant="body1" sx={{ color: "#666" }}>
          Click on any policy below to view the full details
        </Typography>
      </Box>

      <List sx={{ width: "100%" }}>
        {policies.map((policy, index) => (
          <ListItem
            key={index}
            disablePadding
            sx={{ mb: 2 }}
          >
            <Paper
              sx={{
                width: "100%",
                p: 0,
                transition: "all 0.3s ease",
                "&:hover": {
                  boxShadow: 3,
                  transform: "translateY(-2px)",
                },
              }}
            >
              <ListItemButton
                onClick={() => {
                  navigate(policy.path);
                  window.scrollTo({ top: 0 });
                }}
                sx={{
                  p: 3,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: 1,
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    color: "#FF895D",
                    fontSize: "1.2rem",
                  }}
                >
                  {policy.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#666",
                  }}
                >
                  {policy.description}
                </Typography>
                <Typography
                  variant="caption"
                  sx={{
                    color: "#0693e3",
                    fontWeight: "bold",
                    mt: 1,
                  }}
                >
                  Click to Read →
                </Typography>
              </ListItemButton>
            </Paper>
          </ListItem>
        ))}
      </List>

      <ContactInformation title="Contact Us for Policy Questions" />
    </Container>
  );
};

export default AllPolicies;
